export const LINKS = {
  privacyPolicy: "https://www.iubenda.com/privacy-policy/82634676",
  linkedin: "https://www.linkedin.com/company/escrypto-com/",
  twitter: "https://twitter.com/zert_com/",
  youtube: "https://www.youtube.com/@zert_com/",
  zertMain: "https://app.zert.com/",
  idealogic: "https://www.idealogic.io/",
};
